export default "__VITE_ASSET__54SqGxWcyxX4t2USzGY1ag__"